import { useState } from "react";

type PlayerState = "idle" | "loading" | "error";

interface PlayerBoxProps {
  title: string;
  cover: string;
}

export default function PlayerBox({ title, cover }: PlayerBoxProps) {
  const [state, setState] = useState<PlayerState>("idle");

  const handlePlay = () => {
    if (state === "loading") return;
    setState("loading");
    window.setTimeout(() => setState("error"), 1400);
  };

  return (
    <div className="overflow-hidden rounded-lg border border-background-800 bg-background-900">
      <div className="relative aspect-video w-full overflow-hidden bg-background-950">
        <img
          src={cover}
          alt={`${title} 播放预览`}
          title={`${title} - 演示播放器`}
          className="h-full w-full object-cover object-top opacity-30 blur-sm"
        />

        <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
          {state === "idle" ? (
            <>
              <button
                type="button"
                onClick={handlePlay}
                aria-label={`播放 ${title}`}
                className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 transition-transform hover:scale-105 cursor-pointer md:h-20 md:w-20"
              >
                <i className="ri-play-fill text-3xl text-foreground-950 md:text-4xl" />
              </button>
              <p className="mt-4 text-sm text-foreground-200">点击播放预览</p>
              <p className="mt-1 text-xs text-foreground-500">
                演示播放器，暂无实际视频资源接入
              </p>
            </>
          ) : null}

          {state === "loading" ? (
            <>
              <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-accent-500/40">
                <i className="ri-loader-4-line animate-spin text-3xl text-accent-500" />
              </div>
              <p className="mt-4 text-sm text-foreground-300">正在加载播放资源…</p>
              <p className="mt-1 text-xs text-foreground-500">请稍候</p>
            </>
          ) : null}

          {state === "error" ? (
            <>
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-background-800">
                <i className="ri-error-warning-line text-3xl text-accent-500" />
              </div>
              <p className="mt-4 text-sm font-medium text-foreground-100">暂时无法播放</p>
              <p className="mt-1 max-w-md text-xs leading-relaxed text-foreground-400">
                演示播放器，暂无实际视频资源接入。本站仅提供影视资料与推荐展示，不提供在线播放服务。
              </p>
              <button
                type="button"
                onClick={() => setState("idle")}
                className="mt-4 rounded-md border border-background-700 px-4 py-1.5 text-xs text-foreground-200 transition-colors hover:border-accent-500 hover:text-accent-400 whitespace-nowrap cursor-pointer"
              >
                重新尝试
              </button>
            </>
          ) : null}
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-2 border-t border-background-800 px-4 py-3">
        <span className="inline-flex items-center gap-2 text-xs text-foreground-400">
          <i className="ri-information-line text-accent-400" />
          播放区域为界面演示，无实际视频资源接入
        </span>
        <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-hd-line" />
          演示画质 1080P
        </span>
      </div>
    </div>
  );
}